module.exports = __webpack_public_path__ + "static/media/8.afb55a8a.jpg";